import { Pipe, PipeTransform } from '@angular/core';
import { CheckoutContentExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { getBlockImageSrc } from './checkout-content.utils';

@Pipe({
  name: 'blockImageSrc',
  standalone: false,
})
export class BlockImageSrcPipe implements PipeTransform {
  transform(block: CheckoutContentExtension.ImageBlock | CheckoutContentExtension.DynamicBlock): string {
    return getBlockImageSrc(block);
  }
}
